"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeByIntentComponent = exports.LabelComponent = exports.CriticalBadgeComponent = exports.PrimaryBadgeComponent = exports.SuccessBadgeComponent = void 0;
var React = require("react");
var pp_react_1 = require("@paypalcorp/pp-react");
var constants_1 = require("../constants");
var VIEWS = constants_1.default.VIEWS, BADGES = constants_1.default.BADGES;
function SuccessBadgeComponent(_a) {
    var content = _a.content;
    return (React.createElement(pp_react_1.Badge, { className: "badgeComponent", type: "success", status: true }, content));
}
exports.SuccessBadgeComponent = SuccessBadgeComponent;
function PrimaryBadgeComponent(_a) {
    var content = _a.content;
    return (React.createElement(pp_react_1.Badge, { className: "badgeComponent", type: "neutral", status: true }, content));
}
exports.PrimaryBadgeComponent = PrimaryBadgeComponent;
function CriticalBadgeComponent(_a) {
    var content = _a.content;
    return (React.createElement(pp_react_1.Badge, { className: "badgeComponent", type: "critical" }, content));
}
exports.CriticalBadgeComponent = CriticalBadgeComponent;
function LabelComponent(_a) {
    var content = _a.content;
    return (React.createElement(pp_react_1.Text, { className: "managePhones-category_label block-display", size: "sm" }, content));
}
exports.LabelComponent = LabelComponent;
function badgeType(item, type) {
    if (item[VIEWS[type].TOAST_INTENTS.ADD] ||
        item[VIEWS[type].TOAST_INTENTS.ADD_AS_PRIMARY]) {
        return BADGES.NEW;
    }
    if (item[VIEWS[type].TOAST_INTENTS.EDIT] ||
        item[VIEWS[type].TOAST_INTENTS.UPADTE_PRIMARY] ||
        item[VIEWS[type].TOAST_INTENTS.SET_PRIMARY] ||
        item[VIEWS[type].TOAST_INTENTS.REMOVE_PRIMARY] ||
        item[VIEWS[type].TOAST_INTENTS.CONFIRM] ||
        item[VIEWS[type].TOAST_INTENTS.REMOVE_BILLING_PRIMARY] ||
        item[VIEWS[type].TOAST_INTENTS.REMOVE_BILLING_PRIMARY_ADD_NEW] ||
        item[VIEWS[type].TOAST_INTENTS.REMOVE_BILLING] ||
        item[VIEWS[type].TOAST_INTENTS.REMOVE_BILLING_ADD_NEW] ||
        item[VIEWS[type].TOAST_INTENTS.REMOVE_BILLING_ADD_NEW_PRIMARY] ||
        item[VIEWS[type].TOAST_INTENTS.UPDATE_BILLING_PRIMARY] ||
        item[VIEWS[type].TOAST_INTENTS.UPDATE_BILLING] ||
        item[VIEWS[type].TOAST_INTENTS.UPDATE_BILLING_AS_PRIMARY]) {
        return BADGES.UPDATED;
    }
    if (item.primary && type === "ADDRESSES") {
        return BADGES.PRIMARY;
    }
    if (item.primary && type === "PHONES") {
        if (item.type === "WORK")
            return BADGES.PRIMARY_WORK;
        if (item.type === "HOME")
            return BADGES.PRIMARY_HOME;
        if (item.type === "MOBILE")
            return BADGES.PRIMARY_MOBILE;
    }
    if (!item.primary && type === "PHONES") {
        if (item.type === "WORK")
            return VIEWS.PHONES.LABELS.WORK;
        if (item.type === "HOME")
            return VIEWS.PHONES.LABELS.HOME;
        if (item.type === "MOBILE")
            return VIEWS.PHONES.LABELS.MOBILE;
    }
}
function commonBadges(type, item, commonContent, specificContent) {
    var tagComponent = React.createElement(React.Fragment, null);
    switch (badgeType(item, type)) {
        case BADGES.PRIMARY: {
            tagComponent = (React.createElement(PrimaryBadgeComponent, { content: commonContent.primary }));
            break;
        }
        case BADGES.PRIMARY_WORK: {
            tagComponent = (React.createElement(PrimaryBadgeComponent, { content: specificContent.primaryTag.work }));
            break;
        }
        case BADGES.PRIMARY_HOME: {
            tagComponent = (React.createElement(PrimaryBadgeComponent, { content: specificContent.primaryTag.home }));
            break;
        }
        case BADGES.PRIMARY_MOBILE: {
            tagComponent = (React.createElement(PrimaryBadgeComponent, { content: specificContent.primaryTag.mobile }));
            break;
        }
        case BADGES.NEW: {
            tagComponent = (React.createElement(SuccessBadgeComponent, { content: commonContent.new }));
            break;
        }
        case BADGES.UPDATED: {
            tagComponent = (React.createElement(SuccessBadgeComponent, { content: commonContent.updated }));
            break;
        }
        case VIEWS.PHONES.LABELS.WORK: {
            tagComponent = (React.createElement(LabelComponent, { content: specificContent.category.work }));
            break;
        }
        case VIEWS.PHONES.LABELS.HOME: {
            tagComponent = (React.createElement(LabelComponent, { content: specificContent.category.home }));
            break;
        }
        case VIEWS.PHONES.LABELS.MOBILE: {
            tagComponent = (React.createElement(LabelComponent, { content: specificContent.category.mobile }));
            break;
        }
    }
    return tagComponent;
}
function BadgeByIntentComponent(_a) {
    var type = _a.type, item = _a.item, commonContent = _a.commonContent, content = _a.content;
    switch (type) {
        case "ADDRESSES":
            return commonBadges(type, item, commonContent, null);
        case "PHONES":
            return commonBadges(type, item, commonContent, content);
        default:
            return React.createElement(React.Fragment, null);
    }
}
exports.BadgeByIntentComponent = BadgeByIntentComponent;
